import { graphql } from '@/generated/gql';

export const INTAKE_REQUEST_DETAILS = graphql(/* GraphQL */ `
  query IntakeRequestDetails($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        request {
          id
          accountingAreaId
          commodityGroupId
          costCenterId
          currency
          deliveryLocationId
          organizationId
        }
        requirementsExtraction {
          id
          extractedData
          enhancedData
          processingStatus
        }
      }
    }
  }
`);
